export const SATCHEL_STYLES = ['Buckled leather', 'Drawstring sack', 'Scout roll'] as const;
export const SHRINE_STYLES = ['Wayside saint', 'Tide votive', 'Woodland lantern'] as const;
export const CRYSTAL_STYLES = ['Azure spires', 'Amethyst fan', 'Low mineral seam'] as const;

/** Stable cosmetic variation: reconnecting or moving a container does not change its model. */
export function satchelVariant(id: string) {
  let hash = 2166136261;
  for (const char of id) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return (hash >>> 0) % SATCHEL_STYLES.length;
}
